module.exports = __webpack_public_path__ + "static/media/22.8d0f851a.mp3";